import { NgModule, ModuleWithProviders } from '@angular/core';

import { AnnotateServiceConfig, ANNOTATE_CONFIG } from './annotate.config';
import { AnnotateService } from './annotate.service';

@NgModule({
  providers: [
    AnnotateService,
  ],
})
export class AnnotateModule {

  static forRoot(config: AnnotateServiceConfig): ModuleWithProviders<AnnotateModule> {
    return {
      ngModule: AnnotateModule,
      providers: [
        AnnotateService,
        {
          provide: ANNOTATE_CONFIG,
          useValue: config,
        },
      ],
    };
  }

  static forChild(config: AnnotateServiceConfig): ModuleWithProviders<AnnotateModule> {
    return AnnotateModule.forRoot(config);
  }

}
